import styles from './CartMobileItem.module.scss'
import QuantityInput from '@/components/inputs/QuantityInput/QuantityInput'
import React from 'react'
import { CartRowModel } from '@/types/api'
import useCartRow from '@/utils/hooks/useCartRow'
import { roboto } from '@/utils/fonts'
import usePrice from '@/utils/hooks/usePrice'
import Image from 'next/image'
import CartItemSettings from '../CartItemSettings/CartItemSettings'
import CartTyre from '../CartTyre/CartTyre'
import CarModel from '../CarModel/CarModel'
import { convertToURL } from '@/utils/helpers'
import Link from 'next/link'
import Button from '@/components/buttons/Button/Button'
import { useTranslation } from 'next-i18next'
import WheelPackage from '../WheelPackage/WheelPackage'
import useLocalizedLink from '@/utils/hooks/useLocalizedLink'
import StockStatus from '@/components/article/StockStatus/StockStatus'

type Props = {
  item: CartRowModel
}

const CartMobileItem = ({ item }: Props) => {
  const { updateQuantity } = useCartRow(item)
  const { price } = usePrice()
  const { t } = useTranslation(['cart', 'common'])
  const getLocalizedLink = useLocalizedLink()

  let productLink = getLocalizedLink(item.productLink)

  return (
    <div className={styles.component}>
      <div className={styles.row}>
        <div className={styles.image}>
          {item.imageId && (
            <Link href={productLink}>
              <Image
                src={`${process.env.NEXT_PUBLIC_API}/images/${item.imageId}`}
                style={{ objectFit: 'contain' }}
                width={80}
                height={80}
                alt={item.articleText}
              />
            </Link>
          )}
        </div>
        <div className={roboto.className}>
          <div className={styles.articleText}>
            {item.articleText}
          </div>
          <div className={styles.stockStatus}>
            <StockStatus
              article={item}
              light={true}
            />
          </div>
          <div className={styles.price}>
            {price(item.price * item.quantity, true)}
          </div>
        </div>
        <div className={styles.quantity}>
          <QuantityInput
            value={item.quantity}
            onChange={updateQuantity}
          />
        </div>
      </div>
      <CarModel
        licensePlate={item.licensePlate}
        carModel={item.carModel}
      />
      <WheelPackage
        item={item}
      />
      <CartTyre
        item={item}
      />
      <CartItemSettings
        item={item}
      />
    </div>
  )
}

export default CartMobileItem
